import { Lock } from "lucide-react";

const LEVELS = [
  { n: 1, label: "Shy" },
  { n: 2, label: "Bonding" },
  { n: 3, label: "Unlocked" },
];

export default function TrustScoreBar({ score = 0 }) {
  const level = score <= 30 ? 1 : score <= 70 ? 2 : 3;
  return (
    <div data-testid="trust-score-bar" className="w-full">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Trust</span>
        <span className="text-[10px] font-semibold text-brand">{score}/100</span>
      </div>
      <div className="relative h-2 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full rounded-full bg-brand transition-[width] duration-500" style={{ width: `${score}%` }} />
      </div>
      <div className="flex items-center justify-between mt-2">
        {LEVELS.map((l) => (
          <div key={l.n} className={`flex items-center gap-1 text-[10px] ${level >= l.n ? "text-white" : "text-muted-foreground/50"}`}>
            {level < l.n && <Lock className="w-2.5 h-2.5" />}
            {l.label}
          </div>
        ))}
      </div>
    </div>
  );
}
